import React from 'react';

import { StyledNavigation } from '../Styled';

interface NavigationInterface {
  isActive: boolean;
  children: JSX.Element;
}

export const Navigation = (props: NavigationInterface): JSX.Element => {
  const { isActive } = props;

  return (
    <>
      {isActive ? (
        <StyledNavigation data-testid="styled-navigation">{props.children}</StyledNavigation>
      ) : (
        props.children
      )}
    </>
  );
};
